import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { AxiosError } from 'axios';
import { getPhotographer } from '../../../providers/api/shooting/photographerProvider';
import { Photographer } from '../../../providers/api/dtos';

export const PHOTOGRAPHER_RID = '/photographers/:id';

export default function usePhotographer(
  photographerId?: Photographer['id'],
  options?: SWRConfiguration<Photographer, AxiosError>,
): SWRResponse<Photographer, AxiosError> {
  const key = photographerId ? [PHOTOGRAPHER_RID, photographerId] : null;

  return useSWR(key, () => getPhotographer(photographerId!), options);
}
